module.exports = __webpack_public_path__ + "static/media/subscription.f20b1c7c.svg";